import { createContext, useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import useContextHook from './useContextHook';

const Context = createContext(null);
Context.displayName = 'Theme';

export const Provider = ({ children }) => {
  // Always use dark theme
  const [theme] = useState('dark');

  useEffect(() => {
    // Update the HTML element class for dark theme
    document.documentElement.classList.remove('light');
    document.documentElement.classList.add('dark');

    // Update meta theme-color for dark theme
    const metaThemeColor = document.querySelector('meta[name="theme-color"]');
    if (metaThemeColor) {
      metaThemeColor.setAttribute('content', '#000000');
    }
  }, []);

  const value = useMemo(
    () => ({
      theme,
      isDark: true
    }),
    [theme]
  );

  return <Context.Provider value={value}>{children}</Context.Provider>;
};

Provider.propTypes = {
  children: PropTypes.node.isRequired
};

export const useTheme = () => useContextHook(Context);
